<template>
    <v-list-item-avatar :class="[color, className]" :size="size" tile style="border-radius: 3px;">
        <span :class="['white--text', text_class]">
            {{ clientInitials }}
        </span>
    </v-list-item-avatar>
</template>

<script>
import { computed } from "@vue/composition-api";

export default {
    name: "ClientAvatarListItem",
    props: {
        color: {
            type: String,
            required: true
        },
        clientInitials: {
            type: String,
            required: true
        },
        size: {
            type: Number,
            default: 24
        },
        className: {
            type: String,
            default: "mr-2 my-1"
        }
    },
    setup(props) {
        const text_class = computed(function() {
            return props.clientInitials != null && props.clientInitials.length > 2 ? "caption" : "body-2";
        });
        return {
            text_class
        };
    }
};
</script>
